import jwt_decode from "jwt-decode";
import store from './storage';

const useGetToken = (decode?: boolean) => {
  const parts = window.location.pathname.split('/');

  if (decode) {
    try {
      return jwt_decode(parts[parts.length - 1]);
    } catch {
      return null;
    }
  }

  return parts[parts.length - 1];
}

const getToken = () => {
  if (window.location.pathname.indexOf('/portal/') > -1) {
    return window.location.pathname.split('/')[3];
  }

  return store.get('id_token', undefined) || (window as any).document.getElementById('id_token')?.value || undefined;
}

const isValidToken = () => {
  const token: any = getToken();
  if (token && token.exp) {
    return Date.now() < token.exp * 1000;
  }

  return true;
}

const setToken = (token: String) => {
  store.set('id_token', token);
}

const decodeToken = () => {
  return getToken() ? jwt_decode(getToken()) : undefined;
}

export {
  useGetToken,
  getToken,
  setToken,
  isValidToken,
  decodeToken
}
